module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_sjobo-e98119bf2b08e5c5ae4e44c36ed6987d.png";